import React from 'react';

import get from 'lodash.get';
import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';

import RichTextField, { RichTextBox } from 'components/RichTextField/RichTextField';

import { cardShape } from 'shapes/components/iconCardBlockShape';

import { autoOptimizeImage } from 'utils/functions';

const FuturesTradeTitle = styled.h3`
  font-size: 1.17em;
  font-weight: 700;
  max-width: 9.375rem;
  text-transform: uppercase;

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    min-height: 2.8125rem;
  }

  ${switchProp('$alignment', {
    Left: css`
      margin-right: auto;
    `,
    Center: css`
      margin-left: auto;
      margin-right: auto;
    `,
    Right: css`
      margin-left: auto;
    `,
  })}
`;

const IconImage = styled.img`
  height: 5rem;
  margin-bottom: 1.5rem;
`;

const CalloutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: fit-content;

  ${switchProp('$contentAlignment', {
    Left: css`
      text-align: left;
    `,
    Center: css`
      margin: 0 auto;
      text-align: center;
    `,
    Right: css`
      text-align: right;
    `,
  })}

  ${RichTextBox} {
    font-weight: 400;
  }
`;

CardContent.propTypes = {
  data: cardShape,
};

function CardContent({ data }) {
  const { contentAlignment, description, icon, title } = data;

  return (
    <CalloutWrapper $contentAlignment={contentAlignment}>
      <div>
        {title && <FuturesTradeTitle $alignment={contentAlignment}>{title}</FuturesTradeTitle>}
        {icon && <IconImage src={autoOptimizeImage(get(icon, 'iconAsset.url'))} />}
      </div>
      {description && <RichTextField richText={description} />}
    </CalloutWrapper>
  );
}

export default CardContent;
